import { BaseSignalr } from './signalr.js';
export class NoticeSignalr extends BaseSignalr {
    RequestUserOrderRecord({ address, addressList, minTimestamp }) {
        console.log('invoke RequestUserOrderRecord', address, addressList, minTimestamp);
        return this.invoke('RequestUserOrderRecord', {
            Address: address,
            AddressList: addressList,
            MinTimestamp: minTimestamp,
        });
    }
    ReceiveUserOrderRecords({ address, addressList }, callback) {
        return this.listen('ReceiveUserOrderRecords', (data) => {
            var _a;
            console.log('listen ReceiveUserOrderRecords', data);
            if ((data === null || data === void 0 ? void 0 : data.address) === address || ((_a = data === null || data === void 0 ? void 0 : data.addressList) === null || _a === void 0 ? void 0 : _a.length) === (addressList === null || addressList === void 0 ? void 0 : addressList.length)) {
                callback(data);
            }
            else {
                callback(null);
            }
        });
    }
    UnsubscribeUserOrderRecord(address, addressList) {
        console.log('invoke UnsubscribeUserOrderRecord', address, addressList);
        return this.invoke('UnsubscribeUserOrderRecord', {
            Address: address,
            AddressList: addressList,
        });
    }
}
export var NOTICE_SIGNALR_METHODS;
(function (NOTICE_SIGNALR_METHODS) {
    NOTICE_SIGNALR_METHODS["RequestUserOrderRecord"] = "RequestUserOrderRecord";
    NOTICE_SIGNALR_METHODS["ReceiveUserOrderRecords"] = "ReceiveUserOrderRecords";
    NOTICE_SIGNALR_METHODS["UnsubscribeUserOrderRecord"] = "UnsubscribeUserOrderRecord";
})(NOTICE_SIGNALR_METHODS || (NOTICE_SIGNALR_METHODS = {}));
export const NOTICE_LISTEN_LIST = [
    NOTICE_SIGNALR_METHODS.RequestUserOrderRecord,
    NOTICE_SIGNALR_METHODS.ReceiveUserOrderRecords,
    NOTICE_SIGNALR_METHODS.UnsubscribeUserOrderRecord,
];
export const noticeSignalr = new NoticeSignalr({
    listenList: NOTICE_LISTEN_LIST,
});
